import { ChatMessage } from 'types/Chat';
import { v4 as uuidV4 } from 'uuid';

export const getChatMessage = (options?: {
  message?: string;
  awaiting?: boolean;
  isAiResponse?: boolean;
}): ChatMessage => ({
  id: uuidV4(),
  createdAt: new Date().toISOString(),
  replyToMessageId: null,
  feedbackPositive: null,
  message: options?.message || 'Thinking',
  awaiting: options?.awaiting || false,
  isAiResponse: options?.isAiResponse || false,
});
